import { createContext } from 'react';
import type { TourDefinition } from './tourTypes';

export interface TourApi {
  /** Starts a tour by id, even if it has been seen before. */
  start: (id: string) => void;
  /**
   * Starts a tour the way auto-start would: only for signed-in users who
   * haven't seen this version, and not over an open modal. For pages that pick
   * a tour from their own data, e.g. the offer page choosing by role.
   */
  autoStart: (id: string) => void;
  stop: () => void;
  isActive: boolean;
  activeTourId: string | null;
  /** Every tour the current user can take. */
  tours: TourDefinition[];
}

export const TourContext = createContext<TourApi | null>(null);
